import axios from "axios"
import moment from "moment"
import i18n from "i18next"
import config from '../config'

const { AUTH_URL } = config.mediaforta


export default class AuthService {
  static getToken() {
    const user = AuthService.getCurrentUser()
    return user ? user.token : false
  }

  static setUserStorage({token, user}, cb) {
    if (! token || ! user) return false
    const { password, ...userData }  = user
    const data = {
      user: userData,
      token,
      expiry: moment().add(user.tokenExpiresMinutes, 'minutes').toDate()
    }
    localStorage.setItem("mediaforta-user", JSON.stringify(data))
    if (cb) cb(data)
    return data
  }

  // Recruiters do not get a session here: the server answers with a short lived
  // challenge (mfaToken) that only verify2FA can exchange for a real token.
  static login({email, password}) {
    return axios.post(AUTH_URL + "login", {
        email,
        password
      }).then(({ data }) => {
        if (data.mfaRequired) return data
        return AuthService.setUserStorage(data)
      })
  }

  static verify2FA({mfaToken, code}) {
    return axios.post(AUTH_URL + "2fa/verify", {
        mfaToken,
        code
      }).then(({ data }) => AuthService.setUserStorage(data))
  }

  static removeJobId() {
    const currentUser = AuthService.getCurrentUser()
    if (currentUser) {
      const { user: {jobId, ...data} } = currentUser
      currentUser.user = data
      localStorage.setItem("mediaforta-user", JSON.stringify(currentUser))
      return true
    }
    return false
  }

  static updateUserLanguage(language) {
    const currentUser = AuthService.getCurrentUser()
    if (currentUser) {
      currentUser.user.language = language
      localStorage.setItem("mediaforta-user", JSON.stringify(currentUser))
      
      const userLang = ['nl', 'fr', 'en'].includes(language.toLowerCase()) ? language : 'en'
      if (userLang !== i18n.language.toLowerCase()) i18n.changeLanguage(userLang.toUpperCase())
      
      return true
    }
    return false
  }

  static logout() { 
    return localStorage.removeItem("mediaforta-user") 
  }

  static getCurrentUser() {
    const item = JSON.parse(localStorage.getItem('mediaforta-user'))
    if (! item) return false
    if (moment(item.expiry).isBefore(moment())) return this.logout()
    return JSON.parse(localStorage.getItem('mediaforta-user')) || false
  }
}
